import React from "react";
import { InnerNav } from "../components/InnerNav";
import { Hero } from "../components/Hero";
import { Marquee } from "../components/Marquee";
import { Manifesto } from "../components/Manifesto";
import { Discover } from "../components/Discover";
import { Music } from "../components/Music";
import { EntertainmentTeaser } from "../components/EntertainmentTeaser";
import { People } from "../components/People";
import { History } from "../components/History";
import { CinemaAISection } from "../components/CinemaAI";
import { Community } from "../components/Community";
import { Footer } from "../components/Footer";
import { useAi } from "../context/AiContext";

export default function Home() {
  const { openAi } = useAi();

  return (
    <div className="relative">
      <InnerNav back={false} />
      <Hero onAsk={() => openAi("What should I watch tonight?")} />
      <Marquee />
      <Manifesto />
      <Discover />
      <Music />
      <EntertainmentTeaser />
      <People />
      <History />
      <CinemaAISection onOpen={openAi} />
      <Community />
      <Footer />
    </div>
  );
}
